import React from 'react';
import PropTypes from 'prop-types';
import QuizTitle from './QuizTitle/QuizTitle';
import QuizDescription from './QuizDescription/QuizDescription';
import Button from './Button/Button';
import Questions from './Questions/Questions';
import FinalCalculationsBar from './FinalCalculationsBar/FinalCalculationsBar';
import LoginForm from './Form/LoginForm';
import PasswordForm from './Form/PasswordForm';
import QuizSubtitle from '../QuizDetails/QuizTitle/QuizSubtitle';


const QuizDetails = (props) => {
    const {data, toNextStep, answers, sendRequest, dataFromForm, dataFormPass, dataUserName, btnLoading, reportError} = props;

    const quizTitleElem = (
        data.title &&
        <QuizTitle stepTitle={data.title} stepBigTitle={data.bigTitle}/>
    );

    const subtitleElem = data.subtitle && <QuizSubtitle subtitle={data.subtitle}/>;

    const startBtn = (
        data.button && data.button.type === 'start' &&
        <Button buttonData={data.button} toNextStep={toNextStep}/>
    );

    const questionsElem = (
        data.questions &&
        <Questions
            stepQuestions={data.questions}
            toNextStep={toNextStep}
            stepTitle={data.title}
        />
    );

    const quizDescElem = data.desc && <QuizDescription stepDesc={data.desc}/>;
    const finalCalcElem = data.calculations && <FinalCalculationsBar toNextStep={toNextStep}/>;
    const formNameEmail = (
        data.isLogin &&
        <LoginForm
            dataFromForm={dataFromForm}
            formData={data}
            answers={answers}
            toNextStep={toNextStep}/>
    );
    const formPassword = (
        data.isPassword &&
        <PasswordForm
            dataFormPass={dataFormPass}
            dataUserName={dataUserName}
            formData={data}
            answers={answers}
            toNextStep={toNextStep}/>
    );

    const finishBtn = (
        data.button && data.button.type === 'finish' &&
        <div className="clear">
            {reportError &&
            <p className="mb-0 error__message">Error: Something went wrong!</p>
            }

            <button
                type="submit"
                className={`button button_${data.button.style} btn_continue_report ` + (btnLoading ? ' loading__btn' : '')}
                onClick={sendRequest}
            >{(btnLoading ? 'Loading...' : data.button.text)}</button>
        </div>
    );

    return (
        <div>
            {formNameEmail}
            {formPassword}
            {quizTitleElem}
            {subtitleElem}
            {quizDescElem}
            {startBtn}
            {questionsElem}
            {finalCalcElem}
            {finishBtn}
        </div>
    );
};

QuizDetails.propTypes = {
    data: PropTypes.object.isRequired,
    toNextStep: PropTypes.func.isRequired,
    answers: PropTypes.array.isRequired,
    reportError: PropTypes.bool
};

export default QuizDetails;


// WEBPACK FOOTER //
// ./src/components/Quiz/QuizDetails/QuizDetails.js